import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import * as CONST from "../../../component/config/Constant"
import axios from 'axios';
import parse from 'html-react-parser';
import Moment from "moment";
import { useParams } from 'react-router-dom';
import Pagination from '../../../component/utilities/Pagination';
import DivSpinner from '../../../component/utilities/Spinner';
import { Helmet } from "react-helmet";
import { FiCalendar, FiGrid } from "react-icons/fi";
import "../../../assets/css/home.css";

function List() {
    const [eventList, setEventList] = useState("");
    const [eventCatList, setEventCatList] = useState("");
    const params = useParams();
    const categoryId = params.category_id ? params.category_id : 0;
    const [currentPage, setCurrentPage] = useState("1");
    const [totalCount, setTotalCount] = useState(0);
    const [postsPerPage] = useState(6);
    const paginate = pageNumber => setCurrentPage(pageNumber);

    const fetchEventData = async (cat_id) => {
        await axios.post(CONST.WEB_GET_EVENTDATA, {
            sort: { order: "asc", order_by: "id" },
            page_number: currentPage,
            limit: postsPerPage,
            category_id: cat_id
        }).then((response) => {
            if (response.data.status === 'success') {
                setEventList(response.data.data);
                setTotalCount(response.data.count);
            }
        }).catch((error) => console.log(error));
    }

    const fetchEventCatList = async () => {
        await axios.get(CONST.WEB_GET_EVENTCATDATA).then((response) => {
            if (response.data.status === 'success') setEventCatList(response.data.data);
        }).catch((error) => console.log(error));
    }

    useEffect(() => {
        fetchEventData(categoryId);
        fetchEventCatList();
    }, [])

    return (
        <>
            <Helmet><title>Events | HRD Portal - eLuminous Technologies</title></Helmet>

            <section className="events-hero">
                <div className="container">
                    <div className="events-hero-row">
                        <div className="events-hero-icon"><FiCalendar /></div>
                        <div>
                            <h1 className="events-hero-title">Company Events</h1>
                            <p className="events-hero-sub">Celebrating moments that bring our team together</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="events-list-section">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="row">
                                {eventList && eventList.length > 0 ? (
                                    eventList.map((element, key) => (
                                        <div className="col-lg-6 col-md-6 mb-4" key={key}>
                                            <Link to={`/event/${element.id}`} className="event-card-link">
                                                <div className="event-list-card">
                                                    {element.e_event_images && element.e_event_images.map((ele, eKey) => (
                                                        ele.is_featured_image == 1 ? (
                                                            <div className="event-list-image" key={eKey}>
                                                                <img src={CONST.HOST + ele.image_path} alt={element.title} />
                                                            </div>
                                                        ) : null
                                                    ))}
                                                    <div className="event-list-body">
                                                        <h5 className="event-list-title">{element.title}</h5>
                                                        {element.event_date && (
                                                            <span className="event-list-date">
                                                                <FiCalendar size={13} /> {Moment(element.event_date).format("DD MMM YYYY")}
                                                            </span>
                                                        )}
                                                        <div className="event-list-desc">
                                                            {parse(element.description.substring(0, 100))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center py-5 text-muted">No events found</div>
                                )}
                            </div>

                            {totalCount > postsPerPage && (
                                <Pagination postsPerPage={postsPerPage} totalPosts={totalCount} paginate={paginate} />
                            )}
                        </div>

                        <div className="col-xl-4 col-lg-5">
                            <div className="events-sidebar">
                                <h6 className="events-sidebar-title"><FiGrid size={16} /> Categories</h6>
                                <ul className="events-cat-list">
                                    {eventCatList ? (
                                        eventCatList.map((element, key) => (
                                            <li key={key}>
                                                <Link to="/events/" onClick={() => fetchEventData(element.id)}>
                                                    <span>{element.name}</span>
                                                    <span className="events-cat-count">{element.eventCount || 0}</span>
                                                </Link>
                                            </li>
                                        ))
                                    ) : <DivSpinner size="sm" color="primary" />}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default List
